module.exports = __webpack_public_path__ + "img/shire.b748652e.png";